<template>
  <div class="insert-sheet-data" v-loading="!availableSheets">
    <div class="row">
      <div class="row-title">选择工作表</div>
      <div class="row-body">
        <tree-select
          v-model="insertData.sheetId"
          :group-list="sheetGroup"
          @input="sheetChange"
        ></tree-select>
      </div>
    </div>
    <div v-if="availableSheets" class="row">
      <div class="row-title">新增记录</div>
      <div class="row-tip" v-if="!insertData.sheetId">
        必须先指定一个工作表后，才能设置新增记录
      </div>
      <div v-else class="row-body">
        <el-form
          :rules="rules"
          ref="form"
          :model="insertData.map"
          label-position="top"
          class="form-group"
        >
          <el-form-item
            v-for="control in controls"
            :key="control._cid"
            :prop="control._cid"
            class="form-item"
          >
            <template slot="label">
              <span v-if="control.required" class="require-flag">*</span>
              {{ control.name }}
              <!-- 控件提示 -->
              <el-tooltip
                v-if="control.description"
                :content="control.description"
                placement="bottom"
              >
                <span class="icon-tip pointer">
                  <i class="el-icon-info"></i>
                </span>
              </el-tooltip>
            </template>
            <control-value
              v-model="extra.valueMap[control._cid]"
              @input-val="setVal(control, $event)"
              :control="control"
              :group-list="groupList"
            ></control-value>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="row">
      <div class="row-title">设置</div>
      <div class="row-body setting">
        <el-checkbox v-model="insertData.canTrigger">是否允许触发其他工作流</el-checkbox>
        <el-checkbox v-model="insertData.dealRef" style="margin-top: 10px">
          是否处理关联关系
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import ControlValue from "@/components/Workflow/ControlValue"
import { disabledFieldTypes } from "@/utils/sheet"
import TreeSelect from "@/components/UIComponents/TreeSelect.vue"

export default {
  name: "insert-sheet-data",
  components: {
    ControlValue,
    TreeSelect
  },
  props: {
    insertData: Object,
    extra: Object,
    groupList: Array,
    availableSheets: Array
  },
  computed: {
    sheetGroup() {
      return (this.availableSheets || []).map(app => ({
        label: app.name,
        options: app.sheets.map(sheet => ({
          label: sheet.name,
          value: sheet.sheetId
        }))
      }))
    },
    sheetMap() {
      return this._.keyBy(
        (this.availableSheets || []).flatMap(t => t.sheets),
        "sheetId"
      )
    },
    curSheet() {
      return this.sheetMap[this.insertData.sheetId] || {}
    },
    controls() {
      return (this.curSheet.controls || []).filter(
        control => !disabledFieldTypes.includes(control._type)
      )
    },
    rules() {
      if (this._.isEmpty(this.controls)) return {}
      let rule = {}
      let ruleFunList = [this.requireRule]
      this.controls.forEach(control => {
        let rules = ruleFunList.map(func => func(control)).filter(t => t)
        if (rules.length) {
          rule[control._cid] = rules
        }
      })
      return rule
    }
  },
  methods: {
    requireRule(control) {
      if (!control.required) return null
      let msg = ["file", "staff"].includes(control._type)
        ? "请添加" + control.name
        : "请输入" + control.name
      return {
        validator: (rule, value, callBack) => {
          value = this.insertData.map[control._cid]
          if (this._.isEmpty(value)) callBack(msg)
          callBack()
        },
        trigger: "change"
      }
    },
    setVal(control, val) {
      this.insertData.map[control._cid] = val
      this.$refs.form?.validateField([control._cid])
    },
    sheetChange() {
      this.$set(this.extra, "description", { sheetName: this.curSheet.name })
      this.$set(this.insertData, "map", {})
      this.$set(this.extra, "valueMap", {})
    },
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.insert-sheet-data {
  .row {
    font-size: 13px;
    padding-bottom: 10px;
    .row-title {
      font-weight: bold;
    }
    .row-tip {
      color: #9e9e9e;
    }
    .row-body {
      margin-top: 10px;
      .el-form {
        .el-form-item {
          margin-bottom: 10px;
          ::v-deep {
            .el-form-item__label {
              font-size: 13px;
              padding-bottom: 0;
              line-height: 32px;
            }
          }
        }
      }
      .require-flag {
        color: red;
        font-size: 22px;
        padding-top: 10px;
        top: 6px;
        position: relative;
      }
    }
    .setting {
      display: flex;
      flex-flow: column;
    }
    .row-select {
      margin-top: 10px;
    }
  }
}
</style>
